import { API_RESOURCE } from '@/constants/api.constant'
import OfferPRService from '@/features/offers/services/offerPR.service'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'
import { useMutation } from '@tanstack/react-query'

const useOfferPR = () => {
  const service = new OfferPRService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useSubmitPR = useAction({
    mutationFn: service.submitPR,
    queryKey: queryKey,
    message: 'Successfully Submit PR',
  })
  const useApprovePR = useAction({
    mutationFn: service.approvePR,
    queryKey: queryKey,
    message: 'Successfully Approve PR',
  })
  const useUpdatePRSubmission = useAction({
    mutationFn: service.updatePRSubmission,
    queryKey: queryKey,
    message: 'Successfully Update PR Submission',
  })
  const useRejectPR = useAction({
    mutationFn: service.rejectPR,
    queryKey: queryKey,
    message: 'Successfully Reject PR',
  })
  const useOnHoldPR = useAction({
    mutationFn: service.onHoldPR,
    queryKey: queryKey,
    message: 'Successfully OnHold PR',
  })
  const useResubmitPR = useAction({
    mutationFn: service.resubmitPR,
    queryKey: queryKey,
    message: 'Successfully Resubmit PR',
  })
  const useSplitCostBudget = useAction({
    mutationFn: service.splitCostBudget,
    queryKey: queryKey,
    message: 'Successfully Split Cost Budget',
  })
  const useSelectNewQuotationForOnHold = useAction({
    mutationFn: service.selectNewQuotationForOnHold,
    queryKey: queryKey,
    message: 'Successfully Select New Quotation For OnHold PR',
  })
  const useArchivePR = useAction({
    mutationFn: service.archivePR,
    queryKey: queryKey,
    message: 'Successfully Archive  PR',
  })
  const useDeletePR = useAction({
    mutationFn: service.deletePR,
    queryKey: queryKey,
    message: 'Successfully Delete PR',
  })
  const useBatchApprovePR = useAction({
    mutationFn: service.batchApprovePR,
    queryKey: queryKey,
    message: 'Successfully Batch Approve PR',
    shouldRefresh: false,
  })
  // A download, not a PR mutation: no success toast, no query invalidation.
  const useWorkInstructionDocumentPreview = () =>
    useMutation({
      mutationFn: service.previewWorkInstructionDocument,
    })

  return {
    useSubmitPR,
    useApprovePR,
    useUpdatePRSubmission,
    useRejectPR,
    useOnHoldPR,
    useResubmitPR,
    useSplitCostBudget,
    useSelectNewQuotationForOnHold,
    useArchivePR,
    useDeletePR,
    useBatchApprovePR,
    useWorkInstructionDocumentPreview,
  }
}

export default useOfferPR
